export default __webpack_public_path__ + "fa4b5ef2fb3d819ea6957a108ebd436f.png";